var _defs, _g, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 596.42 597.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #231f20;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 40px;\n      }\n\n      .cls-3 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 199.57,
    cy: 199.57,
    r: 179.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.57,40c42.62,0,82.7,16.6,112.83,46.74,30.14,30.14,46.74,70.21,46.74,112.83s-16.6,82.7-46.74,112.83c-30.14,30.14-70.21,46.74-112.83,46.74s-82.7-16.6-112.83-46.74c-30.14-30.14-46.74-70.21-46.74-112.83s16.6-82.7,46.74-112.83c30.14-30.14,70.21-46.74,112.83-46.74m0-40C89.35,0,0,89.35,0,199.57s89.35,199.57,199.57,199.57,199.57-89.35,199.57-199.57S309.79,0,199.57,0h0Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 322.65,
    y1: 332.35,
    x2: 576.42,
    y2: 577.63
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.6b8d3c99a1ea1c2395a4822475fd64a4.svg";
export { ForwardRef as ReactComponent };